import { ReactComponent as MergeIcon } from "@assets/icons/merge.svg";
import dndStore from "@mobx/store/locations/dnd";
import { ItemStore } from "@mobx/store/locations/interfaces";
import { IRackItem3 } from "@mobx/store/locations/types";
import { hexToRgb } from "@utils/hexToRgb";
import { Tooltip } from "antd";
import cn from "classnames";
import { motion } from "framer-motion";
import { observer } from "mobx-react-lite";
import { MouseEvent, useCallback, useMemo } from "react";
import styles from "./Merge.module.scss";

export interface IMerge3Props {
  readonly itemStore: ItemStore;
  readonly color?: string;
}

const useControl = (props: IMerge3Props) => {
  const item = useMemo(() => props.itemStore.item as IRackItem3, [props.itemStore]);

  const currentColor = useMemo(() => {
    const primaryColor = "#0a28ab";
    const lightColor = "#fff";
    if (!props.color) return primaryColor;
    const parsed = hexToRgb(props.color);
    if (parsed) {
      return (parsed.rgb.r + parsed.rgb.g + parsed.rgb.b) / 3 > 150
        ? primaryColor
        : lightColor;
    }
    return primaryColor;
  }, [props.color]);

  const openTooltip = useMemo(() => !!(item.merge && item.merge.length > 0), [item]);

  const onClick = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();
      props.itemStore.setMerging(!props.itemStore.isMerging);
    },
    [props.itemStore.isMerging]
  );
  
  return {
    item,
    currentColor,
    openTooltip,

    onClick,
  }
}

const Merge3 = observer((props: IMerge3Props) => {
  const ctrl = useControl(props);
  const rackStore = props.itemStore.rackStore;
  return (
    <Tooltip
      open={ctrl.openTooltip ? undefined : false}
      trigger={"hover"}
      destroyTooltipOnHide
      placement='bottom'
      overlayInnerStyle={{
        backgroundColor: "#fff",
      }}
      color='#fff'
      title={
        <div
          className={styles.tooltipWrapper}
          title='Unmerge'
          onClick={() => rackStore.unmergeMinerCells(ctrl.item.id)}
        >
          <div className={styles.unmerge} />
        </div>
      }
    >
      <motion.div
        className={cn(styles.wrapper, {
          [styles.canMerge]: props.itemStore.isMerging,
          [styles.unmerge]: ctrl.openTooltip,
        })}
        onClick={ctrl.onClick}
        drag={props.itemStore.isMerging}
        onDragStart={() => dndStore.onDragStart(props.itemStore.itemIndex, rackStore.rack.id, ctrl.item)}
        onDragEnd={dndStore.onDragFinish}
      >
        <MergeIcon className={styles.icon} style={{ fill: ctrl.currentColor }} />
      </motion.div>
    </Tooltip>
  );
});

Merge3.displayName = "Merge3";

export default Merge3;